__webpack_require__.p = "/voc-banner-revamp/referrals-hub/";